import { render, staticRenderFns } from "./indexWhen.vue?vue&type=template&id=60a4d8d6&"
import script from "./indexWhen.vue?vue&type=script&lang=ts&"
export * from "./indexWhen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports